import {mapLegacyPagination} from '@/store/utils'
import * as mutationTypes from './mutation-types'
import api from '@/store/api/customer/product'
// Modules
import bundles from './bundles'
import numbers from './numbers'
import services from './services'
import tariffs from './tariffs'

const initialState = () => ({
    products: {
        data: [],
        pagination: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        products: state => state.products.data,
        pagination: state => state.products.pagination
    },
    actions: {
        /**
         * @param {{customerId: number, params: {}}} data
         * @returns {Promise<*>}
         */
        listProducts: async ({commit, dispatch}, data) => {
            try {
                const response = await api.listProducts(data)
                const products = {
                    ...response,
                    pagination: mapLegacyPagination(response.pagination)
                }

                commit(mutationTypes.SET_PRODUCTS, products)
                return products
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetProducts: ({commit}) => commit(mutationTypes.RESET_PRODUCTS)
    },
    modules: {
        bundles,
        numbers,
        services,
        tariffs
    },
    mutations: {
        [mutationTypes.RESET_PRODUCTS]: (state) => Object.assign(state, initialState()),
        [mutationTypes.SET_PRODUCTS]: (state, data) => state.products = data
    }
}
